jQuery(document).ready(function($){
    $(document.body).removeClass('no-js').addClass('js');
    
	var ppp = 2; // Post per page
	var pageNumber = 1;


	function initLoadMoreBoardMember(){
	    pageNumber++;
	    var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=load_board_members';
	    $.ajax({
	        type: "POST",
	        dataType: "html",
	        url: '/wp-admin/admin-ajax.php',
	        data: str,
	        success: function(data){
	            var $data = $(data);
	            if($data.length != 0){
	                $("#postCurrentData").append($data);
	                
	            } 
	        },
	        error : function(jqXHR, textStatus, errorThrown) {
	            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
	        }

	    });
	    return false;
	}

	$("#load_more_board a").on("click",function(e){ 
		e.preventDefault();
		 var postLengthBoard = $("#postCurrentData").length;
		 if(postLengthBoard < 2){ 
		 	$("#load_more_board").hide(); 
		 }
	    initLoadMoreBoardMember();
	   
	});

	var postperpage = 8; // Post per page
	var pageNum = 1;
	function initLoadMoreTeamMember() {
	    pageNum++;
	    var str = '&pageNumber=' + pageNum + '&ppp=' + postperpage + '&action=load_team_members';
	    $.ajax({
	        type: "POST",
	        dataType: "html",
	        url: '/wp-admin/admin-ajax.php',
	        data: str,
	        success: function(data){
	            var $data = $(data);
	            if($data.length){
	                $("#postCurrentDataTeam").append($data);
	            } 
	        },
	        error : function(jqXHR, textStatus, errorThrown) {
	            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
	        }

	    });
	    return false;

	}
	$("#team-member a").on("click",function(e){ 
		e.preventDefault();
		var postLengthTeam = $("#postCurrentDataTeam").length;
		 if(postLengthTeam < 8){ 
		 	 $("#team-member").hide(); 
		 }
	    initLoadMoreTeamMember();
	});


	var newsperpage = 5; // Post per page
	var newspageNum = 1;
	function initLoadMoreNews() {
	    newspageNum++;
	    var str = '&pageNumber=' + newspageNum + '&ppp=' + newsperpage + '&action=load_more_news';
	    $.ajax({
	        type: "POST",
	        dataType: "html",
	        url: '/wp-admin/admin-ajax.php',
	        data: str,
	        success: function(data){
	            var $data = $(data);
	            if($data.length != 0){
	                $("#newsroomData").append($data);
	            }
	        }, 
	        error : function(jqXHR, textStatus, errorThrown) {
	            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
	        }

	    });
	    return false;

	}
	$("#load_more_news a").on("click",function(e){ 
		e.preventDefault();
		var postLengthTeam = $("#newsroomData").length;
		 if(postLengthTeam < 55){ 
		 	 $("#load_more_news").hide(); 
		 }
	    initLoadMoreNews();
	});


	var eventperpage = 10; // Post per page
	var eventpageNum = 1;
	function initLoadMoreEvents() {
	    eventpageNum++;
	    var str = '&pageNumber=' + eventpageNum + '&ppp=' + eventperpage + '&action=load_more_events';
	    $.ajax({
	        type: "POST",
	        dataType: "html",
	        url: '/wp-admin/admin-ajax.php',
	        data: str,
	        success: function(data){
	            var $data = $(data);
	            if($data.length != 0){
	                $("#eventData").append($data);
	            }
	        }, 
	        error : function(jqXHR, textStatus, errorThrown) {
	            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
	        }

	    });
	    return false;

	}
	$("#load_more_event a").on("click",function(e){ 
		e.preventDefault();
		var postLengthTeam = $("#eventData").length;
		 if(postLengthTeam < 10){ 
		 	 $("#load_more_event").hide(); 
		 }
	    initLoadMoreEvents();
	});


	
	var keypageNum = 1;
	function initLoadMoreKey() {
	    keypageNum++;
	    var str = '&pageNumber=' + keypageNum +'&action=load_more_key';
	    $.ajax({
	        type: "POST",
	        dataType: "html",
	        url: '/wp-admin/admin-ajax.php',
	        data: str,
	        success: function(data){
	            var $data = $(data);
	            if($data.length != 0){
	                $("#keyData").append($data);
	            }
	        }, 
	        error : function(jqXHR, textStatus, errorThrown) {
	            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
	        }

	    });
	    return false;

	}
	$("#load_more_pub a").on("click",function(e){ 
		e.preventDefault();
		var postLengthTeam = $("#keyData").length;
		 if(postLengthTeam < 5){ 
		 	 $("#load_more_pub").hide(); 
		 }
	    initLoadMoreKey();
	});


	//authorSectionHide
	 var authorLength = $("#authorData .module__news--list").length;
	 if(authorLength == 0){
	 	$("#authorsection").hide();
	 }

});
